import { render } from "./ResumoPedido.vue?vue&type=template&id=422f1cb6&scoped=true"
import script from "./ResumoPedido.vue?vue&type=script&lang=js"
export * from "./ResumoPedido.vue?vue&type=script&lang=js"

import "./ResumoPedido.vue?vue&type=style&index=0&id=422f1cb6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\catalogo\\catalogo-pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422f1cb6"]])

export default __exports__